import {
  CompetitionStream,
  CompetitionCategoryData,
  CompetitionPlayerFullView,
} from './../../../../data/mygolf.data';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Location } from '@angular/common';
import { SessionDataService } from './../../../../redux/session/session-data-service';
import { SessionInfo } from './../../../../data/authentication-info';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { adjustViewZIndex } from 'src/globals';
import { CompetitionService } from './../../../../providers/competition-service/competition-service';
import {
  CompetitionPlayerInfo,
  CompetitionInfo,
  CompetitionCategory,
} from './../../../../data/competition-data';
import { AuthenticationService } from './../../../../authentication-service';
import { RemoteHttpService } from './../../../../remote-http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ActionSheetController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import { isBlank } from 'src/providers/common-service';
import { ImageZoomPage } from '../../modal-screens/image-zoom/image-zoom.page';
import {
  CompetitionData,
  GameRoundInfo,
  PlayerInfo,
  CompetitionRoundSession,
  PlayerDataLite,
  CompetitionPlayerData,
} from 'src/data/mygolf.data';
import { JsonService } from 'src/json-util';
import { PlayerService } from 'src/providers/player-service/player-service';
import { ProfilePage } from '../../profile/profile.page';
import { finalize, Observable, observable, of } from 'rxjs';

import * as moment from 'moment';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { DescriptionModalPage } from '../competitions-modal/description-modal/description-modal.page';
import * as global from 'src/globals';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

import { orderBy } from 'natural-orderby';
import { AppCustomizerService } from 'services/app-customizer-service/app-customizer.service';
// import {Keyboard} from '@awesome-cordova-plugins/keyboard';
// CompetitionPlayerInfo,
export interface PlayerSession extends CompetitionPlayerData {
  session?: any; //CompetitionRoundSession;
}
@Component({
  selector: 'app-competition-players',
  templateUrl: './competition-players.page.html',
  styleUrls: ['./competition-players.page.scss'],
})
export class CompetitionPlayersPage implements OnInit {
  appFooterHide: boolean = true;
  //private actionSheet: ActionSheet;
  public competition: CompetitionInfo & CompetitionData;
  public players: Array<CompetitionPlayerData> = new Array<CompetitionPlayerData>();
  public filteredPlayers: Array<PlayerSession | CompetitionPlayerFullView> = //CompetitionPlayerInfo> =
    new Array<PlayerSession>();
  public roundNo: number;
  public visible: boolean;
  public searchQuery: string = '';

  public sortBy: string = 'name';
  public sortByBoolean: boolean;
  public sortByDisplay: string = '';
  public sortToggle: boolean = true;
  public categories: Array<CompetitionCategoryData> = new Array<CompetitionCategoryData>();
  public showCategoryName: string;

  compData: CompetitionData;
  compId: number;

  filteredByGroup: string;
  playerGroupsList: Array<CompetitionPlayerData>;

  selectedCompStream: CompetitionStream = null;
  selectedCompCategory: CompetitionCategoryData = null;
  constructor(
    private router: Router,
    public nav: NavController,
    private renderer: Renderer2,
    private keyboard: Keyboard,
    private toastCtl: ToastController,
    public navParams: NavParams,
    private http: RemoteHttpService,
    private loadingCtl: LoadingController,
    private actionSheetCtl: ActionSheetController,
    private auth: AuthenticationService,
    private platform: Platform,
    private sessionService: SessionDataService,
    private compService: CompetitionService,
    private route: ActivatedRoute,
    private location: Location,
    private modalCtl: ModalController,
    private playerService: PlayerService,
    private competitionService: CompetitionService,
    private flightService: ClubFlightService,
    private mg2uUtils: mygolfUtils,
    private customizerService: AppCustomizerService
  ) {
    if (!this.router.getCurrentNavigation().extras.state) {
      this.onHomeClick();
    }

    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.players = this.router.getCurrentNavigation().extras.state.players;
    this.roundNo = this.router.getCurrentNavigation().extras.state.roundNo;
    this.categories = this.router.getCurrentNavigation().extras.state.categories;
    this.visible = false;
    this.searchQuery = '';
    this.filteredPlayers = this.players;
    this.showCategoryName = 'All Categories';
    this.sortBy = 'name';
    this.sortByBoolean = false;
    this.sortByDisplay = 'Handicap';

    this.compData = this.competitionService.getCompData();
    this.onRefreshClick(null, null);
  }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
  }

  ngOnInit() {}

  async onRefreshClick(filter, refresher) {
    let loader = await this.loadingCtl.create({
      message: 'Loading player list, Please wait...',
      duration: 5000,
      backdropDismiss: true,
    });

    // this.compData = this.competitionService.getCompData();

    loader.present().then(() => {
      this.compService.getPlayersRegistered(this.compId, this.sortBy).subscribe(
        (players: any) => {
          loader.dismiss().then(() => {
            this.players = players;
            // this.filteredPlayers = this.players;
            // console.debug(" refresh players ", this.filteredPlayers, this.compData)
            if (this.compData?.gameRounds && this.compData?.gameRounds[0]?.sessions?.length > 0) {
              this._constructPlayerSessions();
              this.compRoundSession = this.compData?.gameRounds[0].sessions;
            }

            this.onSearchCancel();
            this.searchQuery = '';
            if (refresher) refresher.detail.complete();
          });
        },
        error => {
          loader.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error refreshing the registered players'
            );
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          });
        },
        () => {
          if (refresher) refresher.detail.complete();
          if (filter) this.onSearchInput(null);
          if (this.platform.is('ios') && this.platform.is('capacitor')) this.keyboard.hide();
        }
      );
    });
    // this.getRegisteredPlayers();
    this.getRegisteredPlayerViews();
  }

  playerViews: Array<CompetitionPlayerFullView> = [];

  async getRegisteredPlayerViews() {
    let loader = await this.loadingCtl.create({
      message: 'Loading player list, Please wait...',
      duration: 5000,
      backdropDismiss: true,
    });
    loader.present();
    this.flightService
      .getCompPlayersView(this.compId)
      .pipe(
        finalize(() => {
          if (loader) loader.dismiss();
        })
      )
      .subscribe((players: Array<CompetitionPlayerFullView>) => {
        this.playerViews = players;
        this.filteredPlayers = players;
      });
  }

  registeredPlayers: Array<CompetitionPlayerData> = [];
  async getRegisteredPlayers() {
    let loader = await this.loadingCtl.create({
      message: 'Loading player list, Please wait...',
      duration: 5000,
      backdropDismiss: true,
    });
    loader.present();
    this.flightService
      .getCompRegisteredPlayers(this.compId, this.sortBy)
      .pipe(
        finalize(() => {
          if (loader) loader.dismiss();
        })
      )
      .subscribe(
        (players: Array<CompetitionPlayerData>) => {
          this.registeredPlayers = players;
          this.filteredPlayers = players;
          this.playerGroupsList = this.mg2uUtils.getUnique(players, 'groupName');
          this.playerGroupsList.sort((a, b) => {
            if (a < b) return -1;
            else if (a > b) return 1;
            else return 0;
          });
          this.playerGroupsList = this.playerGroupsList.filter(p => {
            return p.groupName?.length;
          });
          // console.debug(" refresh players ", this.filteredPlayers, this.compData)
          if (this.compData?.gameRounds && this.compData?.gameRounds[0]?.sessions?.length > 0) {
            this._constructPlayerSessions();
            this.compRoundSession = this.compData?.gameRounds[0].sessions;
          }

          this.onSearchCancel();
          this.searchQuery = '';
        },
        error => {
          let msg = MessageDisplayUtil.getErrorMessage(
            error,
            'Error refreshing the registered players'
          );
          MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          if (loader) loader.dismiss();
        },
        () => {}
      );
  }

  toggle(searchBar, search) {
    this.visible = searchBar;
    //searchBar.setFocus();
    if (this.visible) {
    }
  }

  onSearchCancel() {
    this.toggle(false, null);
  }

  onHomeClick() {
    this.customizerService.goToPlayerHome();
    // this.router.navigate(['tabs/player-home']);
  }

  onSearchInput(searchbar) {
    // console.debug(" player session ", this.filteredPlayers, this.compData);
    if (this.searchQuery && this.searchQuery.length > 0)
      this.filteredPlayers = this.playerViews.filter((p: CompetitionPlayerFullView) => {
        return (
          p?.player.playerName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0 ||
          p?.groupName?.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0
        );
      });
    else this.filteredPlayers = this.playerViews;
    this.showCategoryName = 'All Categories';
  }

  toggleSortDisplay(str: string) {
    // this.sortByBoolean = !this.sortByBoolean;
    // if (this.sortByBoolean) {
    //     this.sortBy        = 'handicap';
    //     this.sortByDisplay = 'Name';
    // }
    // else {
    //     this.sortBy        = 'name';
    //     this.sortByDisplay = "Handicap";
    // }
    if (this.sortBy == 'name') {
      this.sortBy = 'handicap';
      this.sortByDisplay = 'Name';
      this.sortToggle = true;
      this.onRefreshClick(true, null);
    } else if (this.sortBy == 'handicap') {
      this.sortBy = 'name';
      this.sortByDisplay = 'Handicap';
      this.sortToggle = false;
      this.onRefreshClick(true, null);
    }
    // if (this.sortBy !== str) {
    //   this.sortBy = str;
    //   this.onRefreshClick(true, null);
    // }
  }

  getSortBy(sortBy: string) {
    // defining class

    if (sortBy == 'name' && this.sortBy == 'name') return 'sortedBy';
    if (sortBy == 'handicap' && this.sortBy == 'handicap') return 'sortedBy';
  }

  public async onMenuSortClick() {
    let actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Sort By : ' + this.sortByDisplay,
          role: 'destructive',
          cssClass: 'sort-by',
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.toggleSortDisplay('');
            });

            return false;
          },
        },
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });
    await actionSheet.present();
  }

  getFlagUrl(flagUrl: string) {
    if (flagUrl === null || isBlank(flagUrl)) return null;
    else {
      let flagIcon = flagUrl.split('/');
      // return "img/flag/"+flagUrl.split[2]
      return 'img/flag/' + flagIcon[2];
    }
  }

  public checkScoringCategory() {
    let hasScoringCategory: boolean = false;
    this.categories.forEach((c: CompetitionCategory) => {
      if (c.forGrouping) {
        hasScoringCategory = true;
        // return c.forGrouping
      }
    });
    return hasScoringCategory;
  }

  public async openCategory() {
    let buttons: any = [
      {
        text: 'Cancel',
        role: 'cancel', // will always sort to be on the bottom
        icon: !this.platform.is('ios') ? 'close' : null,
        handler: () => {
          actionSheet.dismiss();
          return false;
        },
      },
    ];

    let tempCategoryName = '';
    if (this.categories.length > 0) tempCategoryName = 'All Categories';
    else tempCategoryName = 'No Category';

    buttons.push({
      text: tempCategoryName,
      role: 'destructive',
      icon: 'filter',
      handler: () => {
        actionSheet.dismiss().then(() => {
          //   this.selectedCategoryId = "";
          //   this._setLeaderboardFilter();

          this.showCategoryName = tempCategoryName;
          this.filteredPlayers = this.players;
        });
        return false;
      },
    });

    this.categories.forEach((c: CompetitionCategory) => {
      if (c.forGrouping) {
        buttons.push({
          text: c.categoryName + ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')',
          role: 'destructive',
          icon: 'filter',
          handler: () => {
            actionSheet.dismiss().then(() => {
              this.showCategoryName =
                c.categoryName + ' (' + c.fromHandicap + ' - ' + c.toHandicap + ')';
              this.filteredPlayers = this.players.filter((p: CompetitionPlayerData) => {
                return p.category === c.categoryName;
              });
              //   this.selectedCategoryId = String(c.categoryId);
              //   this._setLeaderboardFilter();
            });
            return false;
          },
        });
      }
    });

    let actionSheet = await this.actionSheetCtl.create({
      buttons: buttons,
    });

    actionSheet.present();
  }

  onBackpage() {
    this.location.back();
    // this.router.navigate(['tabs/competition-details']);
  }
  goHome() {
    this.customizerService.goToPlayerHome();
    // this.router.navigate(['tabs/player-home']);
  }
  async onZoomImage(item: CompetitionPlayerInfo & any, type: string) {
    if (!item) return;
    let _description = '';
    let _image = '';
    if (type === 'country') {
      // console.debug('on zoom image [0]: ', this.getFlagUrl(item.nationalFlag));
      // console.debug('on zoom image [1]: ', item?.player?.nationality?.flagUrl);
      // console.debug('on zoom image [2]: ', this.getFlagUrl(item?.player?.nationality?.flagUrl));

      if (global?.appClient === 'WAGC') {
        if (this.getFlagUrl(item?.countryFlag))
          _image = 'assets/' + this.getFlagUrl(item?.countryFlag);
        else if (this.getFlagUrl(item?.player?.country?.flagUrl))
          _image = 'assets/' + this.getFlagUrl(item?.player?.country?.flagUrl);
        else _image = 'assets/image/' + 'flag/default_worldwide.png';
        if (item?.countryName)
          _description = item.playerName + (item.countryName ? '<br>' + item.countryName : '');
        else
          _description =
            item?.player?.playerName +
            (item?.player?.country?.name ? '<br>' + item?.player?.country?.name : '');
      } else {
        if (this.getFlagUrl(item.nationalFlag))
          _image = 'assets/' + this.getFlagUrl(item.nationalFlag);
        else if (this.getFlagUrl(item?.player?.nationality?.flagUrl))
          _image = 'assets/' + this.getFlagUrl(item?.player?.nationality?.flagUrl);
        else _image = 'assets/image/' + 'flag/default_worldwide.png';

        if (item?.nationalityName)
          _description =
            item.playerName + (item.nationalityName ? '<br>' + item.nationalityName : '');
        else if (item?.player?.nationality)
          _description =
            item?.player?.playerName +
            (item?.player?.nationality?.name ? '<br>' + item?.player?.nationality?.name : '');
      }
    } else if (type === 'player') {
      // console.debug("zooming image ", item, type, this.getPlayerImage(item))
      if (item?.photoUrl) _image = item.photoUrl;
      else if (this.getPlayerImage(item)) _image = this.getPlayerImage(item);
      _description = item.playerName ? item.playerName : '';
    }

    // console.debug(" zoom image ", type, _image, item)

    const modal: any = await this.modalCtl.create({
      component: ImageZoomPage,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        image: _image,
        description: _description,
        descTopDown: 'top',
      },
    });
    await modal.present();
  }

  onShowPlayerDetails(event, item: any) {
    console.debug('on show player details : ', event, item);
    let _playerId = item?.playerId || item?.player?.id;
    this.getPlayerInfo(_playerId)
      .then(async (result: any) => {
        if (result && result.status === 'success') {
          let _player;
          if (result.data) {
            _player = result.data;
            // JsonService.deriveFulImageURL(_player, 'thumbnail');
            // JsonService.deriveFulImageURL(_player,'photoUrl');
          }

          let modal = await this.modalCtl.create({
            component: ProfilePage,
            componentProps: {
              status: 'view',
              type: 'viewCompProfile',
              player: of(_player),
              openedModal: true,
              currentCompPlayer: item,
              currentTeeBox: item?.teeBox,
            },
          });
          await modal.present();
        }
      })
      .catch(() => {});
  }
  getPlayerInfo(playerId: number) {
    return new Promise((resolve, reject) => {
      this.playerService.getPlayerInfo(playerId).subscribe(
        (playerInfo: PlayerInfo) => {
          if (playerInfo) {
            resolve({
              status: 'success',
              data: playerInfo,
            });
          }
        },
        error => {
          reject({
            status: 'failed',
            data: error,
            error: error,
          });
        },
        () => {}
      );
    });
  }

  showHandicap() {
    // console.debug("show handicap check : ", this.compData)
    // if(!this.compData) return;
    if (this.compData?.proCompetition) return false;
    if (this.compData?.status === 'Completed') return true;
    if (!this.compData?.handicapFormat) return true;
    if (this.compData?.totalRounds <= 1) {
      if (this.compData?.handicapFormat) {
        if (
          this.compData?.handicapFormat?.name.toLowerCase().includes('peoria') ||
          this.compData?.handicapFormat?.name.toLowerCase() === 'system36'
        ) {
          return false;
        } else return true;
      } else return true;
    } else if (this.compData?.totalRounds > 1) {
      let _round = this.compData.gameRounds.find((round: GameRoundInfo) => {
        return round.roundNo === this.roundNo;
      });
      if (_round?.status === 'Completed') return true;
      else {
        if (this.compData?.handicapFormat) {
          if (
            this.compData?.handicapFormat?.name.toLowerCase().includes('peoria') ||
            this.compData?.handicapFormat?.name.toLowerCase() === 'system36'
          ) {
            return false;
          } else return true;
        } else return true;
      }
    }
  }

  _constructPlayerSessions() {
    let _round = this.compData.gameRounds.find(gameRounds => {
      return gameRounds.roundNo === 1;
    });
    this.filteredPlayers.forEach((player: any & PlayerSession) => {
      player.session = _round.sessions.find((session: CompetitionRoundSession) => {
        let _playerSession = session.sessionPlayers.find((playerSession: PlayerDataLite) => {
          // console.debug("construct player ", player, session)
          return (
            playerSession.id === player?.player.playerId ||
            playerSession.playerId === player?.player.playerId
          );
        });
        return _playerSession;
      });
    });
  }

  selectedSession: CompetitionRoundSession;
  compRoundSession: Array<CompetitionRoundSession> = [];
  async onChangeSession() {
    let _dataList = [];

    _dataList.push({
      id: null,
      name: 'All Sessions',
    });
    this.compRoundSession.sort((a, b) => {
      if (a.sessionDate < b.sessionDate) return -1;
      if (a.sessionDate > b.sessionDate) return 1;
      return 0;
    });
    this.compRoundSession.forEach((session: CompetitionRoundSession) => {
      let _sessionTime = moment(session.startTime, 'HH:mm:ss').format('hh:mm A');
      let _sessionDate = moment(session.sessionDate, 'YYYY-MM-DD').format('ddd, DD MMM YYYY');
      let _playerCount = 0 || session.sessionPlayers?.length;
      const _maxSlots = session?.maxSlots || `<i class="fas fa-infinity"></i>`;
      _dataList.push({
        id: session.sessionId,
        name: `${_sessionDate} ${_sessionTime} (${_playerCount} / ${_maxSlots})`,
      });
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        headerTitle: 'Filter by Session',
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data, this.compRoundSession, this.filteredPlayers);
      if (data?.data) {
        this.selectedSession = this.compRoundSession.find(session => {
          if (data?.data?.id) return session.sessionId === data.data.id;
          else return null;
        });
      }
    });
  }

  getSessionFilterInfo() {
    if (!this.selectedSession) return 'All Sessions';
    let _sessionTime = moment(this.selectedSession.startTime, 'HH:mm:ss').format('hh:mm A');
    let _sessionDate = moment(this.selectedSession.sessionDate, 'YYYY-MM-DD').format(
      'ddd, DD MMM YYYY'
    );
    let _playerCount = 0 || this.selectedSession.sessionPlayers?.length;
    const _maxSlots = this.selectedSession.maxSlots || `<i class="fas fa-infinity"></i>`;
    return `${_sessionDate} ${_sessionTime} (${_playerCount} / ${_maxSlots})`;
  }
  getSessionInfo(session) {
    if (!session) return '';
    let _sessionTime = moment(session.startTime, 'HH:mm:ss').format('hh:mm A');
    return `${_sessionTime}`;
  }

  getFilteredPlayers() {
    let _filtered = [];
    if (this.filteredPlayers?.length) _filtered = this.filteredPlayers;
    // if (this.playerViews?.length) _filtered = this.playerViews;
    if (this.selectedCompStream)
      _filtered = _filtered.filter(player => player.stream?.id === this.selectedCompStream.id);
    if (this.selectedCompCategory) {
      _filtered = _filtered.filter(
        player =>
          player?.category?.id === this.selectedCompCategory.id ||
          player?.competitionCategory?.id === this.selectedCompCategory.id
      );
    }
    // console.debug('filtered players [0]: ', this.filteredPlayers, _filtered);
    // console.debug('filtered players [1]: ', this.filteredByGroup);
    // console.debug('filtered players [2]: ', this.selectedSession, this.compRoundSession);
    if (this.selectedSession) {
      _filtered = _filtered.filter(ps => {
        return this.selectedSession?.sessionPlayers.some(sp => {
          return sp?.id === ps?.player?.id;
        });
        // return ps?.session?.sessionId === this.selectedSession?.sessionId
      });
    }
    if (this.filteredByGroup) {
      _filtered = _filtered.filter(ps => {
        return ps?.groupName === this.filteredByGroup;
      });
    }
    if (_filtered?.length) {
      if (this.sortBy === 'handicap') {
        _filtered.sort((a, b) => {
          if (a?.handicap < b?.handicap) return -1;
          else if (a?.handicap > b?.handicap) return 1;
          else return 0;
        });
      } else {
        _filtered = orderBy(_filtered, x => x.player.playerName?.trim()?.toLowerCase() || '');
        // _filtered.forEach((p, i) => {
        //   p = orderBy(p.player?.playerName?.trim()?.toLowerCase);
        // });
        // _filtered.sort((a, b) => {
        //   const A = this.mg2uUtils.parseStringItem(a?.player?.playerName?.trim()?.toLowerCase());
        //   const B = this.mg2uUtils.parseStringItem(b?.player?.playerName?.trim()?.toLowerCase());

        //   // console.debug('sorting player', a?.player?.playerName, b?.player?.playerName, A, B);
        //   // Compare prefixes alphabetically
        //   if (A.prefix !== B.prefix) {
        //     if (A.prefix < B.prefix) return -1;
        //     else if (A.prefix > B.prefix) return 1;
        //     else return 0;
        //     // return A.prefix.localeCompare(B.prefix);
        //   }

        //   // If both have numeric parts → sort by number
        //   if (A.num !== null && B.num !== null) {
        //     return A.num - B.num;
        //   }

        //   // If only one has a number → number comes first
        //   if (A.num !== null) return -1;
        //   if (B.num !== null) return 1;

        //   // No numbers → sort by whole string
        //   // return a.localeCompare(b);
        //   if (A < B) return -1;
        //   else if (A > B) return 1;
        //   else return 0;

        //   // let _aName = a?.player?.playerName?.trim()?.toLowerCase();
        //   // let _bName = b?.player?.playerName?.trim()?.toLowerCase();
        //   // if (_aName < _bName) return -1;
        //   // else if (_aName > _bName) return 1;
        //   // else return 0;
        // });
      }
    }
    return _filtered;
  }

  parsePlayerStatus(player: PlayerSession) {
    if (!player) return;
    if (player.status === 'Registered') {
      return '';
    } else if (player.status === 'FailedCutoff') {
      return 'CUT';
    } else if (player.status === 'Withdrawn') {
      return 'Withdrawn';
    } else return player.status;
  }

  getPlayerDetails(player: PlayerSession, attribute?: string) {
    if (!player) return;
    let _registeredPlayer = this.registeredPlayers.find((cp: CompetitionPlayerData) => {
      return player.id === cp.id;
    });
    switch (attribute) {
      case 'hidx':
        // console.debug('get player details', player, attribute, _registeredPlayer);
        return _registeredPlayer?.handicapIndex;
    }
  }

  async morePlayersOptions() {
    // this.sortBy = 'name';
    // this.sortByDisplay = 'Handicap';
    let _dataList = [
      {
        id: 'refresh',
        name: 'Refresh',
        iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'toggleSort',
        name: `Sort by ${this.sortByDisplay}`,
        iconUrl: 'assets/icons/book.png',
      },
      // ,{
      //   id: 'lowestAverage',
      //   name: 'Lowest Average',
      //   iconUrl: 'assets/icons/golf-field.png'
      // }
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Players Options',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'refresh') {
          this.onRefreshClick(false, null);
        } else if (data?.data?.id === 'toggleSort') {
          this.toggleSortDisplay(null);
        }
      }
      // if(data)
    });
  }

  getPlayerImage(player) {
    // console.debug("get player image [0] : ", player)
    if (!player) return 'assets/image/default_user.png';
    let _playerImage = '';
    if (player.image) _playerImage = player.image;
    else if (player.profile) _playerImage = player.profile;
    else if (player.playerPhoto) _playerImage = player.playerPhoto;
    else return 'assets/image/default_user.png';

    // console.debug("get player image [1] : ", global.MygolfServerHost + '/' + _playerImage);
    if (_playerImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase()))
      return _playerImage;
    else return global.MygolfServer + '/' + _playerImage;
  }

  async onChangeFilterByGroup() {
    let _dataList = [];
    _dataList.push({
      id: null,
      name: 'All Groups',
    });

    this.playerGroupsList.forEach((group: CompetitionPlayerData) => {
      if (group?.groupName)
        _dataList.push({
          id: group.groupName,
          name: group.groupName,
        });
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        headerTitle: 'Filter by Group',
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0])
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data?.data) {
        this.filteredByGroup = data.data.id;
        // this.selectedSession = this.compRoundSession.find((session)=>{
        //   if(data?.data?.id)
        //     return session.sessionId === data.data.id
        //   else return null;
        // });
      }
    });
  }

  getRosterInfo(player: any, attribute: string) {
    // console.debug('get roster info : ', attribute, player);
    if (!player) return;
    switch (attribute) {
      case 'groupColor':
        return player?.playerGroup?.groupColor;
    }
  }

  getCompStreams() {
    if (!this.compData) return [];
    if (!this.compData?.streams?.length) return [];
    let streams = this.compData?.streams.sort((a: CompetitionStream, b: CompetitionStream) => {
      const aName = a?.name?.trim()?.toLowerCase();
      const bName = b?.name?.trim()?.toLowerCase();
      if (aName < bName) return -1;
      if (aName > bName) return 1;
      return 0;
    });
    return streams;
  }

  getCompCategories() {
    if (!this.compData) return [];
    if (!this.compData?.categories?.length) return [];
    const categories = this.compData?.categories;
    categories.sort((a, b) => {
      const aName = a?.name?.trim()?.toLowerCase();
      const bName = b?.name?.trim()?.toLowerCase();
      if (aName < bName) return -1;
      if (aName > bName) return 1;
      return 0;
    });
    return categories;
  }

  async onChangeCompStream() {
    let _dataList = [];

    _dataList.push({
      id: null,
      name: 'All Streams',
    });
    this.getCompStreams().forEach((stream: CompetitionStream) => {
      let desc = '';
      if (stream?.description) desc = `(${stream?.description?.trim()})`;
      _dataList.push({
        id: stream.id,
        name: `${stream.name} <p>${desc}</p>`,
      });
    });

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        headerTitle: 'Show by Stream',
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data?.data) {
        this.selectedCompStream = this.getCompStreams().find(stream => {
          if (data?.data?.id) return stream.id === data.data.id;
          else return null;
        });
        // this.refreshLeaderboard(null);
      }
    });
  }

  async onChangeCompCategory() {
    let _dataList = [];

    _dataList.push({
      id: null,
      name: 'All Categories',
    });
    const _filteredCategories = this.getCompCategories().filter(cat => {
      if (this.selectedCompStream && this.selectedCompStream?.id === cat?.stream?.id) return true;
      else if (!this.selectedCompStream) return true;
    });
    _filteredCategories.forEach((category: CompetitionCategoryData) => {
      const fromHandicap = category?.fromHandicap || 0;
      const toHandicap = category?.toHandicap || `<i class="fas fa-infinity"></i>`;
      _dataList.push({
        id: category.id,
        name: `${category.name} (HCP ${fromHandicap} to ${toHandicap})`,
      });
    });
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        headerTitle: 'Show by Category',
        mode: 'common',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data?.data) {
        this.selectedCompCategory = this.getCompCategories().find(cat => {
          if (data?.data?.id) return cat.id === data.data.id;
          else return null;
        });
        // this.refreshLeaderboard(null);
      }
    });
  }

  getTeeColor(color: string) {
    if (color === 'White') {
      return 'light';
    } else if (color === 'Red') {
      return 'danger';
    } else if (color === 'Black') {
      return 'dark';
    } else if (color === 'Blue') {
      return 'secondary';
    } else if (color === 'Gold') {
      return 'gold';
    } else if (color === 'Jade') {
      return 'jade';
    } else if (color === 'Silver') {
      return 'tee-silver';
    } else if (color === 'Copper') {
      return 'tee-copper';
    } else return 'secondary';
  }

  getBtnTbox(color: string) {
    let tboxStyle: string;

    if (color === 'White') {
      return 'button-teebox ' + 'button-teebox-white';
    } else return 'button-teebox';
  }
  getTeeColorBG(teeColor: string, teeName?: string) {
    if (teeName === 'White') return '#BDBDBD'; // return '#231f20';
    const _color = teeColor || '#000000';
    if (this.mg2uUtils.lightOrDark(_color) === 'light') {
      return '#BDBDBD'; // '#231f20';
    } else {
      return '#ffffff';
    }
  }

  getPlayerFlag(player) {
    // WAGC - use country
    let _flagImage;
    if (global?.appClient === 'WAGC') {
      _flagImage = player?.player?.countryFlag || player?.player?.country?.flagUrl;
    } else {
      _flagImage = player?.player?.nationalityFlag || player?.player?.nationality?.flagUrl;
    }

    return _flagImage;
  }
}
